import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import LoginForm from "./LoginForm";
import images from "../../constant/images";
import { Trans, useTranslation } from "react-i18next";
import NexbotVideo from "../../assets/video/robot.mp4";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { useLocation } from "react-router-dom";

function LandingLogin() {
  const theme = useTheme();
  const location = useLocation();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsForgotPassword(location.pathname?.includes("reset-password"));
  }, [location.pathname]);

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.brandColor.grey1,
        height: "100vh",
        p: "2rem",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Layer */}
      <Box
        id="background-style"
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          overflow: "hidden",
        }}
      >
        {/* Background image */}
        <Box
          component={"img"}
          src={images.gotbg}
          alt="background"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "90rem",
            height: "90rem",
            borderRadius: "50%",
            border: "0.05rem solid black",
            opacity: 0.15,
            zIndex: -1,
            top: "20%",
            left: "90%",
            transform: "translate(-50%, -50%)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "90rem",
            height: "90rem",
            borderRadius: "50%",
            background: "white",
            backdropFilter: "blur(150px)",
            WebkitBackdropFilter: "blur(150px)",
            boxShadow: "0 0 83px 50px white",
            opacity: 0.4,
            zIndex: 1,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "80rem",
            height: "80rem",
            borderRadius: "50%",
            border: "0.05rem solid black",
            opacity: 0.1,
            zIndex: -1,
            top: "90%",
            left: "10%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: "-10%",
          marginTop: "16rem!important",
          width: "63%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          component={"img"}
          src={images.robo}
          alt="background"
          sx={{
            position: "absolute",
            left: "0",
            bottom: "10%",
            width: "70%",
            height: "70%",
            objectFit: "cover",
            mixBlendMode: "multiply",
          }}
        />
      </Box>

      {/* Foreground Content */}
      <Stack sx={{ zIndex: 2, position: "relative" }} height={"100vh"}>
        <Header />
        <Stack direction={"row"} alignItems={"center"} height={"100%"}>
          {isForgotPassword ? <ForgotPassword /> : <LoginForm />}
        </Stack>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: "500",
              color: theme.palette.brandColor.grey2,
            }}
          >
            <Trans
              i18nKey="PRIVACY"
              components={{
                policy: (
                  <Button
                    variant="text"
                    sx={{
                      p: "0.2rem",
                      minWidth: 0,
                      pointerEvents: "auto",
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "500",
                      textDecoration: "underline",
                      color: "#0166FF",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                  />
                ),
              }}
            />
          </Typography>
        </Box>
      </Stack>

      <Box
        sx={{
          position: "fixed",
          left: "2rem",
          // top: "50%",
          p: "3rem",
          bottom: "4rem",
          transform: "rotate(-90deg)",
          transformOrigin: "left",
          zIndex: 1000000,
          pointerEvents: "none",
        }}
      >
        <Stack direction="row" alignItems="center" gap={"10rem"}>
          <Stack direction="row" alignItems="center" gap={"0.5rem"}>
            <Box
              sx={{
                width: "1.2rem",
                cursor: "pointer",
                transform: "rotate(90deg)",
              }}
              component="img"
              src={images.shieldTick}
            />
            <Typography sx={{ fontSize: "1.1rem", color: "#4C4D4F" }}>
              {t("LABEL_DATA_SECURITY")}
            </Typography>
          </Stack>

          <Typography sx={{ fontSize: "1.1rem", color: "#4C4D4F" }}>
            {t("LABEL_CERTIFY", { year: 2023 })}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}

export default LandingLogin;
